import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    fetchSuccess: false,
    entities: {}
};

const requestGroupConversationLikes = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveGroupConversationLikes = (state, action) => {
    return {
        ...state,
        isFetching: false,
        entities: { ...state.entities, [action.resourceId]: action.data },
        lastUpdated: action.receivedAt
    };
};

const groupConversationLikesFetching = (state) => {
    return {
        ...state,
        isFetching: true,
        fetchSuccess: false
    };
};

const groupConversationLikesFinished = (state, action) => {
    return state.entities[action.resourceId]
        ? {
              ...state,
              isFetching: false,
              fetchSuccess: true,
              entities: {
                  ...state.entities,
                  [action.resourceId]: [...state.entities[action.resourceId], ...action.data]
              },
              lastUpdated: action.receivedAt
          }
        : {
              ...state,
              isFetching: false,
              fetchSuccess: true,
              entities: {
                  ...state.entities,
                  [action.resourceId]: action.data
              },
              lastUpdated: action.receivedAt
          };
};

const handlers = {
    [types.REQUEST_GROUP_CONVERSATION_LIKES]: requestGroupConversationLikes,
    [types.RECEIVE_GROUP_CONVERSATION_LIKES]: receiveGroupConversationLikes,
    [types.FETCH_GROUP_CONVERSATION_LIKES_FETCHING]: groupConversationLikesFetching,
    [types.FETCH_GROUP_CONVERSATION_LIKES_FINISHED]: groupConversationLikesFinished
};

export const getGroupConversationLikes = (state) => {
    return state.groupConversationLikes.entities;
};

export const isGroupConversationLikesFetching = (state) => state.groupConversationLikes.isFetching;
export const isGroupConversationLikesFetchSuccess = (state) => state.groupConversationLikes.fetchSuccess;

export default function groupConversationLikes(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
